import {Button} from '@wandb/weave/components/Button';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import * as Tooltip from '@wandb/weave/components/RadixTooltip';
import React from 'react';

type OverflowMenuProps = {
  children: React.ReactNode;
  isMenuOpen: boolean;
  setIsMenuOpen: (isMenuOpen: boolean) => void;
};

export const PanelOverflowMenu = ({
  isMenuOpen,
  setIsMenuOpen,
  children,
}: OverflowMenuProps) => {
  return (
    <Tooltip.Provider>
      <DropdownMenu.Root
        open={isMenuOpen}
        onOpenChange={setIsMenuOpen}
        modal={false} // Setting this to false so it doesn't interfere with focus
      >
        <DropdownMenu.Trigger asChild>
          <Button
            active={isMenuOpen}
            className="mr-8"
            icon="overflow-horizontal"
            variant="ghost"
            aria-label="More panel actions"
            size="small"
          />
        </DropdownMenu.Trigger>
        <DropdownMenu.Portal>{children}</DropdownMenu.Portal>
      </DropdownMenu.Root>
    </Tooltip.Provider>
  );
};
